import React from 'react';
import { MicroscopeIcon, FlaskConicalIcon, ClipboardCheckIcon, PackageIcon, ShieldCheckIcon, BarChart3Icon, LinkIcon, ThermometerIcon, FileTextIcon, UsersIcon, RepeatIcon, DatabaseIcon } from 'lucide-react';
import { SolutionPageLayout } from '../../components/SolutionPageLayout';
const features = [{
  icon: LinkIcon,
  title: 'LIMS & ELN Integration',
  description: 'Connect directly to your Laboratory Information Management System and Electronic Lab Notebooks. Sync sample data, assay results, and experimental records into your ERP without manual re-entry or CSV exports.'
}, {
  icon: MicroscopeIcon,
  title: 'Operational Tracking for R&D and Production',
  description: 'Track every stage of your pipeline — from early-stage research through process development to commercial manufacturing. Monitor batch progress, resource utilization, and milestone completion in real time.'
}, {
  icon: ShieldCheckIcon,
  title: 'GxP & FDA Compliance',
  description: 'Built-in support for GMP, GLP, and GDP requirements. Maintain 21 CFR Part 11 compliant electronic records with audit trails, electronic signatures, and role-based access controls.'
}, {
  icon: ClipboardCheckIcon,
  title: 'Batch Records & Device History',
  description: 'Generate and manage electronic batch records and device history records automatically. Capture every material, parameter, and operator action with full traceability from raw material to finished product.'
}, {
  icon: FlaskConicalIcon,
  title: 'Formulation & Recipe Management',
  description: 'Manage complex formulations, media recipes, and buffer preparations with version-controlled bills of materials. Track potency, concentration, and expiration across every component.'
}, {
  icon: ThermometerIcon,
  title: 'Environmental & Cold Chain Monitoring',
  description: 'Integrate with environmental monitoring systems to track temperature, humidity, and particulate counts. Maintain cold chain integrity for biologics, reagents, and temperature-sensitive materials.'
}, {
  icon: PackageIcon,
  title: 'Lot Traceability & Expiry Management',
  description: 'Full lot-level traceability with expiration date tracking, FEFO (First Expired, First Out) enforcement, and certificate of analysis management. Be recall-ready at all times.'
}, {
  icon: FileTextIcon,
  title: 'Document Control & SOPs',
  description: 'Centralized document management for SOPs, protocols, validation documents, and regulatory submissions. Version control, review workflows, and training acknowledgment built in.'
}, {
  icon: DatabaseIcon,
  title: 'Instrument & Equipment Qualification',
  description: 'Track instrument calibration schedules, qualification status (IQ/OQ/PQ), and maintenance records. Ensure every piece of equipment is validated and audit-ready.'
}, {
  icon: BarChart3Icon,
  title: 'Process Analytics & Yield Optimization',
  description: 'Analyze batch yields, cycle times, and deviation trends across production runs. Identify process improvements with data from both your ERP and integrated lab systems.'
}, {
  icon: UsersIcon,
  title: 'Training & Competency Management',
  description: 'Track operator training records, certifications, and competency assessments. Ensure only qualified personnel execute critical processes — with automatic enforcement.'
}, {
  icon: RepeatIcon,
  title: 'CAPA & Deviation Management',
  description: 'Structured workflows for deviations, investigations, corrective actions, and preventive actions. Link CAPAs to batch records, equipment, and quality events for full root cause traceability.'
}];
export function BiotechPage() {
  return <SolutionPageLayout label="Biotech" title="ERP purpose-built for biotech operations" subtitle="From lab bench to commercial manufacturing, Thruline connects your LIMS, ELN, and operational data into a single system — so your team can focus on science, not spreadsheets." features={features} data-id="element-403" />;
}